import { NoteAdd } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import TradeAndTargetButtons from "./TradeAndTargetButtons";
import { TokenPageDataRes } from "src/store/features/api/generated";
import { useAppDispatch } from "src/store/store";
import { togglePriceAlertModal } from "src/store/features/PriceAlerts.slice";
import { trackEvent } from "src/Amplitude";
import { CoinPerformanceStyles } from "./styles/CoinPerformance.styles";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import PriceAlertModel from "../markets/PriceAlerts/PriceAlertModel";
import { getTicker } from "src/utils/hooks/useGetTicker";
import ToolBox from "./ToolBox";
import WatchToggle from "../markets/WatchToggle";
import MaintananceTooltip from "../maintenance/MaintenanceToolTip";
import { useMaintenanceState } from "src/store/features/maintenance.slice";

export const buttonTextStyle = {
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "19px",
};

export const buttonStyle = {
  justifyContent: "center",
  alignItems: "center",
  height: "35px",
  borderRadius: "10px",
  border: "1px solid #002035",
  textTransform: "none",
  whiteSpace: "nowrap",
  padding: "12px 8px",
};

export default function CoinButtonGroup(props: { coinData: TokenPageDataRes }) {
  const token = getTicker();
  const dispatchRedux = useAppDispatch();
  const classes = CoinPerformanceStyles();
  const { pricealertcontroller } = useMaintenanceState();

  const WatchListButton = () => (
    <WatchToggle height={"18px"} width={"18px"} code={token} variant={"button"} />
  );

  const PriceAlert = () => {
    const { price, currencyConfig } = props.coinData;

    const handlePriceAlert = (configCode: string) => {
      trackEvent("Coin_Page", { button: "User_Select_Price_Alerts", token }, "Coin_Button_Group");
      dispatchRedux(togglePriceAlertModal());
    };

    return (
      <>
        <MaintananceTooltip
          message="Price alerts are undergoing maintenance. If you need assistance, please contact support"
          disableHover={pricealertcontroller}>
          <Button
            disableRipple
            variant={"outlined"}
            sx={buttonStyle}
            disabled={!pricealertcontroller}
            onClick={() => handlePriceAlert(token)}
            className={classes.priceAlert}
            endIcon={<NotificationAddIcon className={classes.notificationIcon} />}>
            <Typography sx={buttonTextStyle}>{"Alert"}</Typography>
          </Button>
        </MaintananceTooltip>
        <PriceAlertModel
          shouldRedirect={true}
          price={price}
          currencyConfig={currencyConfig}
          subtitle={currencyConfig?.displayName}
          logoUrl={currencyConfig?.logoUrl}
        />
      </>
    );
  };

  return (
    <Stack spacing={2} direction={"row"} alignSelf={"center"}>
      {/* Mobile */}
      <Box display={{ xs: "flex", md: "none" }}>
        <Stack direction="row" spacing={1}>
          <Button
            disableRipple
            onClick={() => trackEvent("User_Click_On_Add_Note_Icon", { token })}
            component="a"
            href="#noteSection"
            variant={"outlined"}
            sx={{ ...buttonStyle, minWidth: "0px", scrollBehavior: "smooth" }}>
            <Typography
              // Remove buttonTextStyle for smaller devices
              sx={{
                ...buttonTextStyle,
                display: { xs: "none", md: "flex" },
                paddingRight: "6px",
              }}>
              Add Note
            </Typography>
            <NoteAdd />
          </Button>
          <ToolBox />
        </Stack>
      </Box>
      {/* Tablet */}
      <Box display={{ xs: "none", md: "flex", lg: "none" }}>
        <Stack spacing={2} direction="row">
          <WatchListButton />
          <TradeAndTargetButtons />
          <ToolBox />
        </Stack>
      </Box>
      {/* Desktop */}
      <Box display={{ xs: "none", lg: "flex" }}>
        <Stack spacing={2} direction="row">
          <PriceAlert />
          <WatchListButton />
        </Stack>
      </Box>
    </Stack>
  );
}
